/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 783YKJdyRRPxZbx3qiNi5Q
// Component: -ZWJykIq5V-3F

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
  useTrigger,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 783YKJdyRRPxZbx3qiNi5Q/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_plasmic_kit_component_props_section.module.css"; // plasmic-import: 783YKJdyRRPxZbx3qiNi5Q/projectcss
import sty from "./PlasmicCardPickerItem.module.css"; // plasmic-import: -ZWJykIq5V-3F/css

import EyeSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__EyeSvg"; // plasmic-import: oFYcZi8LU/icon

createPlasmicElementProxy;

export type PlasmicCardPickerItem__VariantMembers = {
  isSelected: "isSelected";
  large: "large";
};
export type PlasmicCardPickerItem__VariantsArgs = {
  isSelected?: SingleBooleanChoiceArg<"isSelected">;
  large?: SingleBooleanChoiceArg<"large">;
};
type VariantPropType = keyof PlasmicCardPickerItem__VariantsArgs;
export const PlasmicCardPickerItem__VariantProps = new Array<VariantPropType>(
  "isSelected",
  "large"
);

export type PlasmicCardPickerItem__ArgsType = {
  title?: React.ReactNode;
  controls?: React.ReactNode;
  image?: React.ReactNode;
};
type ArgPropType = keyof PlasmicCardPickerItem__ArgsType;
export const PlasmicCardPickerItem__ArgProps = new Array<ArgPropType>(
  "title",
  "controls",
  "image"
);

export type PlasmicCardPickerItem__OverridesType = {
  root?: Flex__<"button">;
};

export interface DefaultCardPickerItemProps {
  title?: React.ReactNode;
  controls?: React.ReactNode;
  image?: React.ReactNode;
  isSelected?: SingleBooleanChoiceArg<"isSelected">;
  large?: SingleBooleanChoiceArg<"large">;
  className?: string;
}

const $$ = {};

function PlasmicCardPickerItem__RenderFunc(props: {
  variants: PlasmicCardPickerItem__VariantsArgs;
  args: PlasmicCardPickerItem__ArgsType;
  overrides: PlasmicCardPickerItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "isSelected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isSelected,
      },
      {
        path: "large",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.large,
      },
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const [isRootFocus, triggerRootFocusProps] = useTrigger("useFocused", {});
  const triggers = {
    focus_root: isRootFocus,
  };

  const styleTokensClassNames = _useStyleTokens();

  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootisSelected]: hasVariant($state, "isSelected", "isSelected"),
          [sty.rootlarge]: hasVariant($state, "large", "large"),
        }
      )}
      data-plasmic-trigger-props={[triggerRootFocusProps]}
    >
      <div
        className={classNames(projectcss.all, sty.freeBox__mWjoK, {
          [sty.freeBoxisSelected__mWjoK5OaEf]: hasVariant(
            $state,
            "isSelected",
            "isSelected"
          ),
          [sty.freeBoxlarge__mWjoKeGuqC]: hasVariant($state, "large", "large"),
        })}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.image,
        })}
      </div>
      <div
        className={classNames(projectcss.all, sty.freeBox__sxDqT, {
          [sty.freeBoxisSelected__sxDqT5OaEf]: hasVariant(
            $state,
            "isSelected",
            "isSelected"
          ),
        })}
      >
        {renderPlasmicSlot({
          defaultContents: "Element footer",
          value: args.title,
          className: classNames(sty.slotTargetTitle, {
            [sty.slotTargetTitleisSelected]: hasVariant(
              $state,
              "isSelected",
              "isSelected"
            ),
          }),
        })}
        {false
          ? renderPlasmicSlot({
              defaultContents: (
                <EyeSvgIcon
                  className={classNames(projectcss.all, sty.svg__es6UG)}
                  role={"img"}
                />
              ),

              value: args.controls,
            })
          : null}
      </div>
      {(triggers.focus_root ? true : false) ? (
        <div className={classNames(projectcss.all, sty.freeBox__rbX2U)} />
      ) : null}
    </button>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "button";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCardPickerItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCardPickerItem__VariantsArgs;
    args?: PlasmicCardPickerItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicCardPickerItem__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicCardPickerItem__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCardPickerItem__ArgProps,
          internalVariantPropNames: PlasmicCardPickerItem__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicCardPickerItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCardPickerItem";
  } else {
    func.displayName = `PlasmicCardPickerItem.${nodeName}`;
  }
  return func;
}

export const PlasmicCardPickerItem = Object.assign(
  // Top-level PlasmicCardPickerItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicCardPickerItem
    internalVariantProps: PlasmicCardPickerItem__VariantProps,
    internalArgProps: PlasmicCardPickerItem__ArgProps,
  }
);

export default PlasmicCardPickerItem;
/* prettier-ignore-end */
